var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eb-course-list-wrapper py-3 px-1"},[_c('ul',{staticClass:"eb-course-list"},_vm._l((_vm.userProducts),function(product){return _c('UserDashboardProductsListItem',{key:product.id,attrs:{"data":product,"purchased":true}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }